export default __webpack_public_path__ + "static/media/palab.20685a9a.ttf";